/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

interface HistoryFilters {
  scope: "my_calls" | "all_calls" | "other_calls";
  query: string;
  date: string;
  oldest: boolean;
  onlyRecorded: boolean;
  participants: string[];
}
const defaults: HistoryFilters = {
  scope: "my_calls",
  query: "",
  date: "",
  oldest: false,
  onlyRecorded: false,
  participants: [],
};
export function readHistoryFilters(key: string): HistoryFilters {
  try {
    let stored: string | null = null;
    try { stored = localStorage.getItem(key); } catch { /* Try tab storage next. */ }
    const value = JSON.parse(stored ?? sessionStorage.getItem(key) ?? "null");
    if (!value || typeof value !== "object") return { ...defaults };
    return {
      scope: ["all_calls", "other_calls"].includes(value.scope)
        ? value.scope
        : "my_calls",
      query: typeof value.query === "string" ? value.query : "",
      date:
        typeof value.date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value.date)
          ? value.date
          : "",
      oldest: value.oldest === true,
      onlyRecorded: value.onlyRecorded === true,
      participants: Array.isArray(value.participants)
        ? [
            ...new Set<string>(
              value.participants.filter(
                (id: unknown): id is string => typeof id === "string",
              ),
            ),
          ]
        : [],
    };
  } catch {
    return { ...defaults };
  }
}
export function writeHistoryFilters(key: string, value: HistoryFilters): void {
  const json = JSON.stringify(value);
  try { localStorage.setItem(key, json); } catch { /* Tab storage can still work. */ }
  try { sessionStorage.setItem(key, json); } catch { /* Filtering still works without storage. */ }
}
